import { render, staticRenderFns } from "./AccountReceivableReport.vue?vue&type=template&id=70fb0296&scoped=true"
import script from "./AccountReceivableReport.vue?vue&type=script&lang=js"
export * from "./AccountReceivableReport.vue?vue&type=script&lang=js"
import style0 from "./AccountReceivableReport.vue?vue&type=style&index=0&id=70fb0296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb0296",
  null
  
)

export default component.exports